import { createUseStyles } from 'react-jss'
import { darkGrey } from '../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  availabilityContainerTitle: {
    color: darkGrey
  },
  timelinesContainer: {
    marginTop: [14, '!important'],
    marginBottom: [10, '!important']
  }
})

export default useStyles
